import axios from "@/config/axios";

const initialState = () => {
  return {
    allLabTests: [],
    newLabGroupWiseTests: [],
    newLabGroupPanelTests: [],
    newLabGroupWiseTestsData: []
  };
};

const state = initialState();

const getters = {
  getAllLabTests: (state) => state.allLabTests,
  getNewLabGroupWiseTests: (state) => state.newLabGroupWiseTests,
  getNewLabGroupPanelTests: (state) => state.newLabGroupPanelTests,
  getNewLabGroupWiseTestsData: (state) => state.newLabGroupWiseTestsData
};

const mutations = {
  setAllLabTests(state, data) {
    state.allLabTests = data;
  },
  setNewLabGroupWiseTests(state, data) {
    state.newLabGroupWiseTests = data
  },
  setNewLabGroupPanelTests(state, data) {
    state.newLabGroupPanelTests = data
  },
  setNewLabGroupWiseTestsData(state, data) {
    state.newLabGroupWiseTestsData = data
  },
  reset: (state) => {
    const initial = initialState();
    Object.keys(initial).forEach((key) => {
      state[key] = initial[key];
    });
  },
};

const actions = {
  fetchAllLabTests: async ({ commit, dispatch }, params) => {
    try {
      commit("setAllLabTests", []);
      let response = await axios.get("/lab-tests", { params });
      commit("setAllLabTests", response.data.data);
    } catch (error) {
      if (error.response) {
        await dispatch("errors/errorResponse", error.response, { root: true });
      }
    }
  },
  fetchLabGroupWiseTests: async ({ commit, dispatch }, params) => {
    try {
      await dispatch("errors/clear", [], { root: true })

      const response = await axios.get("/lab-groups", { params })

      commit("setNewLabGroupWiseTests", response.data.data)

      response.data.tests = response.data.tests.map((e) => {
        e.label_value = e.panel_id + ":" + e._id;
        return e;
      })

      commit("setNewLabGroupWiseTestsData", response.data.tests)
    } catch (error) {
      if (error.response) {
        await dispatch("errors/errorResponse", error.response, { root: true })
      }
    }
  },
  fetchLabPanelsWiseTests: async ({ commit, dispatch }, params) => {
    try {
      await dispatch("errors/clear", [], { root: true })

      const response = await axios.get("/lab-panels", { params })

      // here we need append label_value 

      response.data.data = response.data.data.map((e) => {
        e.label_value = e.panel_id + ":" + e._id;
        return e;
      })
      commit("setNewLabGroupPanelTests", response.data.data)
    } catch (error) {
      if (error.response) {
        await dispatch("errors/errorResponse", error.response, { root: true })
      }
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
